export default __webpack_public_path__ + "static/realWorldImg3-7d31f81e6cc0fea83c1087dd5d43b9e2.png";